<template>
  <div class="bg">
    <div class="search-box">
      <div class="search-input-wrapper">
        <a-input
          ref="searchInput"
          v-model="queryParams.s"
          :placeholder="globalDataArray.siteTemplateLanguage.competition_question"
          @keyup.enter="search"
        >
          <a-icon slot="prefix" type="search" />
          <a-icon
            slot="suffix"
            type="filter"
            :theme="showFilter ? 'twoTone' : 'outlined'"
            @click="toggleFilter"
            :style="{transform: showFilter ? 'rotate(180deg)' : 'rotate(0deg)'}"
          />
        </a-input>

        <!-- 筛选下拉框 -->
        <div ref="filterDropdown" class="filter-dropdown" v-show="showFilter">
          <div class="filters-section">
            <!-- Category section -->
            <div class="category-section" v-if="category.length">
              <a-tabs :default-active-key="queryParams.categoryId" @change="(e) => handleSearch(e, 'categoryId')" size="large" class="no-select">
                <a-tab-pane v-for="tag in category" :key="tag.parentId" :tab="tag.title" />
              </a-tabs>
            </div>

            <!-- Other filters -->
            <div class="filter-row" v-if="competitonSortType.length">
              <span class="filter-label">{{ globalDataArray.siteTemplateLanguage.ranking_status }}:</span>
              <div class="filter-options">
                <template v-for="tag in competitionSignupStatus">
                  <a-checkable-tag
                    :key="tag.itemValue"
                    @change="handleSearch(tag.itemValue, 'signupStatus')"
                    :checked="queryParams.signupStatus === tag.itemValue"
                  >
                    {{ tag.itemText }}
                  </a-checkable-tag>
                </template>
              </div>
            </div>

            <div class="filter-row" v-if="technicalList.length">
              <span class="filter-label">{{ globalDataArray.siteTemplateLanguage.technology }}:</span>
              <div class="filter-options">
                <template v-for="tag in technicalList">
                  <a-checkable-tag
                    :key="tag.parentId"
                    @change="handleSearch(tag.parentId, 'technicalId')"
                    :checked="queryParams.technicalId === tag.parentId"
                  >
                    {{ tag.title }}
                  </a-checkable-tag>
                </template>
              </div>
            </div>

            <div class="filter-row" v-if="localCompetitonSortType.length">
              <span class="filter-label">{{ globalDataArray.siteTemplateLanguage.sort_order }}:</span>
              <div class="filter-options">
                <template v-for="tag in localCompetitonSortType">
                  <a-checkable-tag
                    class="sort-arrow"
                    :key="tag.itemValue"
                    @change="handleSearch1(tag)"
                    :checked="queryParams.sortType[tag.itemValue] !== ''"
                  >
                    <span> {{ tag.itemText }} </span>
                    <span
                      v-if="tag.itemValue !== 'all'"
                      :class="{
                        'active': sortStatus[tag.itemValue],
                        'asc': sortStatus[tag.itemValue] === 'asc',
                        'desc': sortStatus[tag.itemValue] === 'desc'
                      }"
                    >
                      <a-icon type="swap-left" class="start_icon" />
                      <a-icon type="swap-left" class="end_icon" />
                    </span>
                  </a-checkable-tag>
                </template>
              </div>
            </div>

            <div class="filter-row" v-if="localCompetitionYear.length">
              <span class="filter-label">{{ globalDataArray.siteTemplateLanguage.number_of_sessions }}:</span>
              <div class="filter-options">
                <template v-for="tag in localCompetitionYear">
                  <a-checkable-tag
                    :key="tag.itemValue"
                    :checked="queryParams.years.includes(tag.itemValue)"
                    @change="handleChange5(tag.itemValue)"
                  >
                    {{ tag.itemText }}
                  </a-checkable-tag>
                </template>
              </div>
            </div>

            <div class="filter-row" v-if="isClient && isLoggedIn">
              <span class="filter-label">{{ globalDataArray.siteTemplateLanguage.my_competition }}:</span>
              <div class="filter-options">
                <template v-for="tag in myCompetition">
                  <a-checkable-tag
                    :key="tag.itemValue"
                    :checked="queryParams.myCompetition === tag.itemValue"
                    @change="handleChange7(tag.itemValue)"
                  >
                    {{ tag.itemText }}
                  </a-checkable-tag>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  name: 'MultiConditionQueryNew',
  props: {
    queryObject: {
      type: Object,
      default: () => ({})
    },
    conditionQueryList: {
      type: Array,
      default: () => []
    },
    category: { // 赛事分类 类别
      type: Array,
      default: () => []
    },
    competitionTypeList: { // 赛题类别
      type: Array,
      default: () => []
    },
    competitionSignupStatus: { // 赛题报名状态
      type: Array,
      default: () => []
    },
    technicalList: { // 技术
      type: Array,
      default: () => []
    },
    competitonSortType: { // 排序规则
      type: Array,
      default: () => []
    },
    competitionYear: { // 赛题年份
      type: Array,
      default: () => []
    },
    myCompetition: { // 我的比赛
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isLoggedIn: false,
      isClient: false, // 客户端标识，确保SSR水合一致性
      showFilter: false,
      sortStatus: {
        all: '',
        bonus: '',
        end_utc_time: '',
        teams_users: ''
      },
      queryParams: {
        page: 1,
        pageSize: 20,
        type: '', // 赛项类型
        categoryId: '', // 类型
        signupStatus: '', // 赛项状态
        technicalId: '', // 技术
        s: '', // 模糊搜索
        years: [''], // 时间查询
        sortType: {
          all: 'all',
          bonus: '',
          end_utc_time: '',
          teams_users: ''
        }, // 排序
        myCompetition: '', // 我的比赛
        sortBonus: '',
        sortTime: '',
        sessionIds: '',
        isMember: '',
        recordType: '',
        sortTeams: '',
        isManaged: '' // 我的管理
      },
      // 添加本地数据以避免直接修改 props
      localCompetitionSignupStatus: [],
      localCompetitionYear: [],
      localCompetitonSortType: [], // 排序规则
      localMyCompetition: []
    }
  },
  watch: {
    // 监听 props 变化并更新本地数据
    competitonSortType: {
      immediate: true,
      handler(newVal) {
        console.log(newVal, 'newVal')
        newVal.forEach(item => {
          if (item.itemValue === '') {
            item.itemValue = 'all'
          }
        })
        this.localCompetitonSortType = [...newVal]
      }
    },
    competitionYear: {
      immediate: true,
      handler(newVal) {
        this.localCompetitionYear = [...newVal]
      }
    }
  },
  created() {
    // SSR兼容：在created中不设置登录状态，避免服务端客户端不一致
    // this.isLoggedIn 保持默认值 false
  },
  mounted() {
    // 设置客户端状态，确保SSR水合一致性
    this.isClient = true
    this.$nextTick(() => {
    // 在客户端设置正确的登录状态
      this.isLoggedIn = Cookies.get('saiti_access_info') !== undefined
      console.log(this.isLoggedIn, 'mounted中的this.isLoggedIn')
    })

    document.addEventListener('click', this.handleClickOutside)
  },
  updated() {
    this.isLoggedIn = Cookies.get('saiti_access_info') !== undefined
    console.log(this.isLoggedIn, 'updated中的this.isLoggedIn')
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
    // 清除定时器，防止内存泄漏
    clearInterval(this.checkLoginInterval)
  },
  methods: {
    handleChange5(value) {
      if (value === '') {
        this.queryParams.years = ['']
      } else {
        this.queryParams.years = this.queryParams.years.filter(item => item !== '')
        const index = this.queryParams.years.indexOf(value)
        if (index > -1) {
          this.queryParams.years.splice(index, 1)
          if (this.queryParams.years.length === 0) {
            this.queryParams.years.push('')
          }
        } else {
          this.queryParams.years.push(value)
          if (this.queryParams.years.length === this.localCompetitionYear.length - 1) {
            this.queryParams.years.push('')
          }
        }
      }
      console.log(this.queryParams.years, 'queryParams')
      this.queryParams.sessionIds = this.queryParams.years.join(',')
      this.search()
    },
    handleChange7(value) {
      this.queryParams.isMember = ''
      this.queryParams.isManaged = ''
      this.queryParams.recordType = ''
      this.queryParams.myCompetition = value
      if (value === 'manage') {
        this.queryParams.isManaged = '1'
      } else if (value === 'participate') {
        this.queryParams.isMember = '1'
      } else if (value === 'favorites') {
        this.queryParams.recordType = '2'
      } else if (value === 'browse') {
        this.queryParams.recordType = '1'
      } else if (value === '') {
        console.log()
      } else {
        console.log()
      }
      this.search()
    },
    handleChange6(value) {
      console.log(this.myCompetition, 'this.myCompetition')
      this.queryParams.myCompetition = value
      if (value === 'manage') {
        this.queryParams.isMember = ''
        this.queryParams.isManaged = 1
        this.search()
      } else if (value === 'participate') {
        this.queryParams.isManaged = ''
        this.queryParams.isMember = '1'
        this.search()
        /* const params = {
          page: this.queryParams.page,
          pageSize: this.queryParams.pageSize
        }
        this.$emit('getMyCompetition', params)*/
      } else {
        this.queryParams.isManaged = ''
        this.queryParams.isMember = ''
        const params = {
          page: this.queryParams.page,
          pageSize: this.queryParams.pageSize
        }
        if (value === 'favorites') {
          params.recordType = '2'
        } else if (value === 'browse') {
          params.recordType = '1'
        } else if (value === '') {
          this.search()
          return
        } else {
          console.log()
        }
        this.$emit('getBrowserAndBookmark', params)
      }
      console.log(value)
    },
    toggleFilter() {
      this.showFilter = !this.showFilter
    },
    search() {
      const params = structuredClone(this.queryParams)
      delete params.sortType
      this.$emit('multiQuery', params)
    },
    // 关闭筛选下拉框
    handleClickOutside(event) {
      const filterDropdown = this.$refs.filterDropdown
      const searchInput = this.$refs.searchInput.$el
      // 检查点击是否发生在筛选下拉框或搜索输入框内部
      if (filterDropdown && !filterDropdown.contains(event.target) && !searchInput.contains(event.target)) {
        this.showFilter = false
      }
    },
    // 点击标签时触发搜索
    handleSearch(value, key) {
      this.queryParams[key] = value === '' ? '' : value
      this.search()
    },
    handleSearch1(tag) {
      if (tag.itemValue === 'all') {
        this.queryParams.sortTime = ''
        this.queryParams.sortBonus = ''
        this.queryParams.sortTeams = ''
        this.sortStatus = {
          all: 'all',
          bonus: '',
          end_utc_time: '',
          teams_users: ''
        }
        this.queryParams.sortType.all = 'all'
        this.queryParams.sortType.teams_users = ''
        this.queryParams.sortType.bonus = ''
        this.queryParams.sortType.end_utc_time = ''
        this.search()
        return
      }

      const type = tag.itemValue

      // 保存当前点击项的状态
      const currentStatus = this.sortStatus[type]

      // 先清空所有排序状态
      this.sortStatus = {
        all: '',
        bonus: '',
        end_utc_time: '',
        teams_users: ''
      }

      // 清空所有查询参数
      this.queryParams.sortTime = ''
      this.queryParams.sortBonus = ''
      this.queryParams.sortTeams = ''

      // 设置当前点击项的新状态（asc -> desc -> 空 -> asc...）
      if (!currentStatus) {
        this.sortStatus[type] = 'asc'
      } else if (currentStatus === 'asc') {
        this.sortStatus[type] = 'desc'
      } else {
        // 如果当前是desc，则清空当前项，回到'all'状态
        this.sortStatus[type] = ''
        this.sortStatus.all = 'all'
      }

      // 更新查询参数
      if (this.sortStatus.all) {
        this.queryParams.sortType.all = 'all'
        this.queryParams.sortType.teams_users = ''
        this.queryParams.sortType.bonus = ''
        this.queryParams.sortType.end_utc_time = ''
      } else {
        this.queryParams.sortType.all = ''
        if (this.sortStatus.bonus) {
          this.queryParams.sortBonus = this.sortStatus.bonus === 'asc' ? '1' : '2'
          this.queryParams.sortType.bonus = this.sortStatus.bonus
        } else {
          this.queryParams.sortType.bonus = ''
        }
        if (this.sortStatus.end_utc_time) {
          this.queryParams.sortTime = this.sortStatus.end_utc_time === 'asc' ? '1' : '2'
          this.queryParams.sortType.end_utc_time = this.sortStatus.end_utc_time
        } else {
          this.queryParams.sortType.end_utc_time = ''
        }
        if (this.sortStatus.teams_users) {
          this.queryParams.sortTeams = this.sortStatus.teams_users === 'asc' ? '1' : '2'
          this.queryParams.sortType.teams_users = this.sortStatus.teams_users
        } else {
          this.queryParams.sortType.teams_users = ''
        }
      }

      this.search()
      console.log(this.sortStatus, 'sortStatus')
      console.log(this.queryParams, 'queryParams')
    }
  }
}
</script>

<style lang="scss" scoped>
.bg {
  background: #fff;
  padding: 20px;
  margin-bottom: 16px;
}

.search-box {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.search-input-wrapper {
  position: relative;
  width: 600px;
  margin: 20px auto;
}

.comp-type-tabs {
  margin-bottom: 20px;
}

::v-deep .ant-input-affix-wrapper .ant-input {
  height: 3.4em;
  border-radius: 2em;
  padding-left: 50px;
  &::placeholder {
    color: #667084;
  }
}
::v-deep .ant-input-affix-wrapper {
  .ant-input-suffix {
    right: 24px;
  }
  .ant-input-prefix {
    left: 20px;
  }
}

.filter-dropdown {
  position: absolute;
  top: calc(100% + 25px); // 25px的间距
  left: 50%;
  width: 740px;
  transform: translateX(-50%);
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  z-index: 1000;
  max-height: 80vh;
  overflow-y: auto;

  // 修改三角形位置和大小
  &::before,
  &::after {
    content: '';
    position: absolute;
    right: 70px; // 调整位置对准筛选按钮
    left: auto;
    transform: none;
  }

  &::before {
    top: -25px; // 增加三角形高度
    border-left: 14px solid transparent;
    border-right: 14px solid transparent;
    border-bottom: 25px solid #e8e8e8; // 与边框颜色一致
  }

  &::after {
    top: -24px;
    border-left: 13px solid transparent;
    border-right: 13px solid transparent;
    border-bottom: 24px solid white; // 与背景颜色一致
  }
}

.category-section {
  padding: 0;
  background: white;
  position: relative;
  margin-bottom: 24px;
  // 移除自定义的边框
  // border-bottom: 1px solid #E9EDF1;

  ::v-deep .ant-tabs {
    padding: 0;
  }

  ::v-deep .ant-tabs-nav-container {
    margin: 0;
  }

  ::v-deep .ant-tabs-nav-wrap {
    margin: 0;
  }

  ::v-deep .ant-tabs-nav-scroll {
    min-height: 56px;
    padding: 0;
  }

  ::v-deep .ant-tabs-bar {
    // 让 tabs 使用默认边框
    border-bottom: 1px solid #f0f0f0;
    margin: 0;
  }

  ::v-deep .ant-tabs-ink-bar {
    background-color: #1281FF;
    height: 2px;
  }
}

.filters-section {
  padding: 10px 32px 32px 24px;
}

.filter-row {
  margin-bottom: 20px;
  display: flex;

  &:last-child {
    margin-bottom: 0;
  }

  .filter-label {
    font-size: 14px;
    font-weight: 650;
    color: #333;
    line-height: 32px;
  }

  .filter-options {
    flex: 1;
    padding-left: 12px;
    line-height: 32px;

    .ant-tag-checkable {
      margin-right: 8px;
      margin-bottom: 8px;
    }
  }
}
::v-deep .sort-arrow {
  .asc {
    .start_icon {
      color: #666666;
    }
    .end_icon {
      color: #1281FF ;
    }
  }
  .desc {
    .start_icon {
      color: #1281FF;
    }
    .end_icon {
      color: #666666 ;
    }
  }
  .start_icon {
    font-size: 16px;
    transform: rotate(-90deg);
  }
  .end_icon {
    font-size: 16px;
    transform: rotate(90deg);
    margin-left: -7px;
  }
}
.sort-item {
  display: inline-flex;
  align-items: center;
  margin-right: 24px;
  margin-bottom: 8px;

  .sort-arrows {
    display: inline-flex;
    align-items: center;
    margin-left: 8px;
    cursor: pointer;

    .anticon {
      font-size: 14px;
      color: #bfbfbf;
      transform: rotate(90deg); // 竖向显示
      transition: all 0.3s;

      &.active {
        color: #1281FF;
      }

      &.asc {
        transform: rotate(90deg);
      }

      &.desc {
        transform: rotate(-90deg);
      }

      &:hover {
        color: #1281FF;
      }
    }
  }
}

::v-deep .ant-tag.ant-tag-checkable {
  font-size: 14px;
  user-select: none;
  margin-bottom: 8px;
}

::v-deep .ant-tabs-nav .ant-tabs-tab{
  margin: 0;
}

::v-deep .ant-tag-checkable-checked {
  background: white !important;
  color: #1281ff !important;
  border-color: transparent !important;
}

@media screen and (max-width: 768px) {
  .search-input-wrapper {
    width: 100%;
  }

  .filter-dropdown {
    width: calc(100vw - 40px);
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
